<template>
	<div style="width: 55rem; max-width: 100%;" class="m-3">
		<div class="mt-3">
			<div class="d-flex flex-row">
				<div style=" width: 3px; height: 1.5rem; background-color: black; border-radius: 1.5px; "></div>
				<div class="ml-2" style="font-weight: 500">America - Latin</div>
			</div>
			<div class="d-flex flex-row flex-wrap mt-5">
				<el-button class="d-flex flex-row mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('US-WEST-1')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/us.png" />
					<span class="ml-3">
						<span>US-SERVER-1</span>
						<span class="ml-3">N.California</span>
					</span>
				</el-button>
				<el-button class="d-flex flex-row ml-0 mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('US-EAST-1')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/us.png" />
					<span class="ml-3">
						<span>US-SERVER-2</span>
						<span class="ml-3">N.Virginia</span>
					</span>
				</el-button>
			</div>
			<!-- <div class="mt-5">
        <el-button
          style="width: 17.5rem"
          class="d-flex flex-row pl-6 pt-3 p-2"
          round
          plain
          @click="download('SA-EAST-1')"
        >
          <div class="d-flex align-items-center">
            <img
              class="no-select"
              style="margin-bottom: 0.3rem"
              height="15"
              src="/static/flag/br.png"
            />
            <span class="ml-3">
              <span>SA-SERVER-1</span>
              <span class="ml-3">São Paulo</span>
            </span>
          </div>
        </el-button>
      </div> -->
		</div>
		<div class="mt-10">
			<div class="d-flex flex-row">
				<div style=" width: 3px; height: 1.5rem; background-color: black; border-radius: 1.5px; "></div>
				<div class="ml-2" style="font-weight: 500">Europe</div>
			</div>
			<div class="d-flex flex-row flex-wrap mt-5">
				<el-button style="width: 17.5rem" class="d-flex flex-row ml-0 mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('EU-WEST-1')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/ie.png" />
					<span class="ml-3">
						<span>EU-SERVER-1</span>
						<span class="ml-3">Ireland</span>
					</span>
				</el-button>
				<el-button style="width: 17.5rem" class="d-flex flex-row ml-0 mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('EU-CENTRAL-1')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/de.png" />
					<span class="ml-3">
						<span>EU-SERVER-2</span>
						<span class="ml-3">Frankfurt</span>
					</span>
				</el-button>
			</div>
		</div>
		<div class="mt-10">
			<div class="d-flex flex-row">
				<div style=" width: 3px; height: 1.5rem; background-color: black; border-radius: 1.5px; "></div>
				<div class="ml-2" style="font-weight: 500">Asia - Pacific</div>
			</div>
			<div class="d-flex flex-row flex-wrap mt-5">
				<el-button style="width: 17.5rem" class="d-flex flex-row ml-0 mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('AP-NORTHEAST-2')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/kr.png" />
					<span class="ml-3">
						<span>AP-SERVER-2</span>
						<span class="ml-3">Seoul</span>
					</span>
				</el-button>
				<!-- <el-button
          style="width: 17.5rem"
          class="d-flex flex-row pl-6 pt-3 p-2 ml-5"
          round
          plain
          @click="download('AP-SOUTHEAST-1')"
        >
          <img
            class="no-select"
            style="margin-bottom: 0.3rem"
            height="15"
            src="/static/flag/sg.png"
          />
          <span class="ml-3">
            <span>AP-SERVER-2</span>
            <span class="ml-3">Singapore</span>
          </span>
        </el-button> -->
				<el-button style="width: 17.5rem" class="d-flex flex-row ml-0 mr-5 px-5 pt-3 p-2 mb-3 mb-md-0" round plain
					@click="download('VIETNAM')">
					<img class="no-select" style="margin-bottom: 0.3rem" height="15" src="/static/flag/vn.png" />
					<span class="ml-3">
						<span>AP-SERVER-3</span>
						<span class="ml-3">Vietnam</span>
					</span>
				</el-button>
			</div>
			<!-- <div class="d-flex flex-row mt-5">
        <el-button
          style="width: 17.5rem"
          class="d-flex flex-row pl-6 pt-3 p-2"
          round
          plain
          @click="download('AP-SOUTH-1')"
        >
          <img
            class="no-select"
            style="margin-bottom: 0.3rem"
            height="15"
            src="/static/flag/in.png"
          />
          <span class="ml-3">
            <span>AP-SERVER-4</span>
            <span class="ml-3">Mumbai</span>
          </span>
        </el-button>
        <el-button
          style="width: 17.5rem"
          class="d-flex flex-row pl-6 pt-3 p-2 ml-5"
          round
          plain
          @click="download('AP-SOUTHEAST-2')"
        >
          <img
            class="no-select"
            style="margin-bottom: 0.3rem"
            height="15"
            src="/static/flag/au.png"
          />
          <span class="ml-3">
            <span>AP-SERVER-5</span>
            <span class="ml-3">Sydney</span>
          </span>
        </el-button>
      </div> -->
		</div>
	</div>
</template>

<script>
//Lib
import { mapState } from "vuex";
import axios from "axios";

// Constant
import { HOST_URL, PRE_FIX_ROUTE, RENTAL_ROUTE } from "@/constant/routeApi";

export default {
	data() {
		return {
			qualityList: {
				normal: 1,
				optimizePerformance: 2,
			},

			request: {
				quality: 1,
			},
		};
	},

	computed: {
		...mapState({
			user: (state) => state.auth.user,
		}),
		downloadFileName() {
			return `${this.targetImage.id}_${this.removeVietnameseTones(
				this.targetImage.name
			).replaceAll(" ", "_")}_${this.user.username}.rdp`;
		},
	},

	props: {
		targetImage: {
			type: Object,
			default: null,
		},
	},

	methods: {
		//#region Remove Vietnamese tones
		removeVietnameseTones(str) {
			str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
			str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
			str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
			str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
			str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
			str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
			str = str.replace(/đ/g, "d");
			str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
			str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
			str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
			str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
			str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
			str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
			str = str.replace(/Đ/g, "D");
			// Some system encode vietnamese combining accent as individual utf-8 characters
			// Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
			str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
			str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
			// Remove extra spaces
			// Bỏ các khoảng trắng liền nhau
			str = str.replace(/ + /g, " ");
			str = str.trim();
			// Remove punctuations
			// Bỏ dấu câu, kí tự đặc biệt
			str = str.replace(
				/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
				" "
			);
			return str;
		},
		//#endregion

		//#region Download .rdp
		download(server) {
			this.dowloadRdpOnXhr(server);
			// window.open(
			// 	`${HOST_URL.API_URL}${PRE_FIX_ROUTE.RENTAL}${RENTAL_ROUTE.DOWNLOAD_REMOTE_DESKTOP}/${this.targetImage.id}/${server}`
			// );
			// this.$emit("processingEvent", {
			// 	event: "closeThisPopup",
			// });
		},
		dowloadRdpOnXhr(server) {
			axios({
				method: 'GET',
				url: `${HOST_URL.API_URL}${PRE_FIX_ROUTE.RENTAL}${RENTAL_ROUTE.DOWNLOAD_REMOTE_DESKTOP}/${this.targetImage.id}/${server}`,
				withCredentials: true,
				responseType: 'blob',
			})
			.then((response) => {
				const href = URL.createObjectURL(response.data);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = href;
				a.setAttribute('download', `${this.downloadFileName}`);
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(href);
			})
			.catch((error) => {
				console.log(error);
			});
		},
		//#endregion
	},
};
</script>